import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FiChevronDown } from 'react-icons/fi'
import { motion } from 'framer-motion'

import { Container, Title, Buttons, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from './styles'

import { setSort, setType } from '../../store/actions/settings.actions'

function PluginHeader() {
  const dispatch = useDispatch()
  const settings = useSelector((state) => state.settings)

  const [filter1, setFilter1] = useState(false)
  const [filter2, setFilter2] = useState(false)

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: 0.6,
        when: "beforeChildren",
        staggerChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } }
  }

  const handleToggleFilter1 = (e) => {
    e.stopPropagation()
    setFilter1(!filter1)
    setFilter2(false) // Close other dropdown if open
  }

  const handleToggleFilter2 = (e) => {
    e.stopPropagation()
    setFilter2(!filter2)
    setFilter1(false) // Close other dropdown if open
  }

  const handleSortSelection = (sortType) => (e) => {
    e.stopPropagation()
    dispatch(setSort(sortType))
    setFilter1(false)
  }

  const handleTypeSelection = (typeValue) => (e) => {
    e.stopPropagation()
    dispatch(setType(typeValue))
    setFilter2(false)
  }

  return (
    <Container 
      as={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <Title 
        as={motion.h3} 
        variants={itemVariants}
      >
        Plugins
      </Title>
      <Buttons as={motion.div} variants={itemVariants}>
        <Dropdown isOpen={filter1} toggle={handleToggleFilter1} direction="down" container="body">
          <DropdownToggle>
            {settings.sort === 'POPULARITY'
              ? 'popularidade'
              : settings.sort === 'LOWEST_PRICE'
              ? 'menor preço'
              : settings.sort === 'RECENT'
              ? 'mais recente'
              : 'maior preço'}{' '}
            <FiChevronDown />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={handleSortSelection('RECENT')}>mais recentes</DropdownItem>
            <DropdownItem onClick={handleSortSelection('POPULARITY')}>popularidade</DropdownItem>
            <DropdownItem onClick={handleSortSelection('LOWEST_PRICE')}>menor preço</DropdownItem>
            <DropdownItem onClick={handleSortSelection('BIGGEST_PRICE')}>maior preço</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown isOpen={filter2} toggle={handleToggleFilter2} direction="down" container="body">
          <DropdownToggle star="true">
            {settings.type === 'PAID' ? 'plugins pagos' : 'plugins gratuitos'} <FiChevronDown />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={handleTypeSelection('PAID')}>plugins pagos</DropdownItem>
            <DropdownItem onClick={handleTypeSelection('FREE')}>plugins gratuitos</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Buttons>
    </Container>
  )
}

export default PluginHeader
